import { createContext, useContext, useEffect, useMemo, useState } from "react";

const SoundContext = createContext(null);
const STORAGE_KEY = "@PartyGames:somMutado";

export function SoundProvider({ children }) {
  const [mutado, setMutado] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, mutado ? "true" : "false");
    } catch {
      // O jogo continua funcionando quando o navegador bloqueia o armazenamento.
    }
  }, [mutado]);

  const value = useMemo(
    () => ({
      mutado,
      alternarMudo: () => setMutado((valor) => !valor),
      tocarSom: (audioRef, volume) => {
        if (mutado || !audioRef?.current) return;
        if (volume !== undefined) audioRef.current.volume = volume;
        audioRef.current.play().catch(() => {});
      },
    }),
    [mutado],
  );

  return (
    <SoundContext.Provider value={value}>{children}</SoundContext.Provider>
  );
}

export function useSound() {
  const context = useContext(SoundContext);
  if (!context)
    throw new Error("useSound deve ser usado dentro de SoundProvider");
  return context;
}

export function SoundButton({ variante = "fixa" }) {
  const { mutado, alternarMudo } = useSound();
  const inline = variante === "inline";
  const tamanho = inline ? "32px" : "44px";

  return (
    <button
      id={inline ? undefined : "botao-mudo-global"}
      className={`sound-button sound-button-${inline ? "inline" : "fixed"}`}
      onClick={alternarMudo}
      title={mutado ? "Ativar sons" : "Mutar sons"}
      aria-label={mutado ? "Ativar sons" : "Mutar sons"}
      style={{ width: tamanho, height: tamanho }}
      type="button"
    >
      {mutado ? "🔇" : "🔊"}
    </button>
  );
}
